export const CLINIC = {
    name: "Klinica Dentale L'Unite",
    shortName: "L'Unite",
    city: "Valona, Albania",
    phoneDisplay: "351 372 3773",
    whatsapp: "393513723773",
    email: "klinicadentaleunite@gmail.com",
};

export const whatsappLink = (message) =>
    `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
    "Ciao! Vorrei inviare la mia panoramica dentale per ricevere un preventivo gratuito.";

// Immagini sostituibili: basta cambiare gli URL qui sotto
export const IMAGES = {
    hero: "https://images.pexels.com/photos/12251080/pexels-photo-12251080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    reception: "/images/reception.jpg",
    operating: "/images/sala-operativa.jpg",
    exterior: "/images/esterno.jpg",
    tac: "/images/sala-tac.jpg",
    waiting: "/images/sala-attesa.jpg",
    hotel: "https://images.unsplash.com/photo-1552858725-a19e7fcd3ac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMHJvb20lMjBkYXJrJTIwbW9vZHxlbnwwfHx8fDE3ODk5MzEzNDZ8MA&ixlib=rb-4.1.0&q=85",
    transfer:
        "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjaGF1ZmZldXIlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4OTkzMTM0Nnww&ixlib=rb-4.1.0&q=85",
};

export const GALLERY = [
    { src: IMAGES.reception, label: "La Reception" },
    { src: IMAGES.operating, label: "Sala Operativa" },
    { src: IMAGES.exterior, label: "L'Esterno" },
    { src: IMAGES.waiting, label: "Sala d'Attesa" },
];

export const STEPS = [
    {
        n: "01",
        title: "Invia la panoramica",
        text: "Fotografa la tua panoramica dentale e inviala su WhatsApp. Bastano pochi minuti, direttamente dal tuo telefono.",
    },
    {
        n: "02",
        title: "Ricevi il preventivo",
        text: "Entro 24 ore ricevi un piano di trattamento dettagliato, con prezzi chiari e senza alcun impegno.",
    },
    {
        n: "03",
        title: "Volo e accoglienza",
        text: "Pensiamo a tutto noi: volo, hotel e transfer privato. Tu devi solo preparare le valigie.",
    },
    {
        n: "04",
        title: "Il tuo nuovo sorriso",
        text: "Trattamento con tecnologie di ultima generazione e follow-up in italiano anche dopo il rientro.",
    },
];

export const PRICING = [
    {
        treatment: "Impianto dentale singolo",
        italy: "1.500 – 3.000 €",
        valona: "da 450 €",
    },
    {
        treatment: "Arcata completa All-on-4",
        italy: "8.000 – 15.000 €",
        valona: "da 2.900 €",
    },
    {
        treatment: "Corona in zirconio",
        italy: "600 – 1.000 €",
        valona: "da 180 €",
    },
];

export const FAQS = [
    {
        q: "Quanto dura il trattamento implantare?",
        a: "Dipende dal caso: un impianto singolo richiede in genere 2-3 giorni a Valona, mentre le riabilitazioni complete (All-on-4) circa 4-5 giorni. Dopo aver valutato la tua panoramica riceverai un piano preciso con tempi e fasi.",
    },
    {
        q: "Devo tornare più volte in Albania?",
        a: "Nella maggior parte dei casi sono sufficienti due viaggi: uno per il posizionamento degli impianti e uno, dopo l'osteointegrazione, per le corone definitive. Molti lavori provvisori vengono completati già nella prima trasferta.",
    },
    {
        q: "Cosa include il pacchetto tutto incluso?",
        a: "Volo di andata e ritorno dall'Italia, hotel a Valona, transfer privati tra aeroporto, hotel e clinica, e assistenza in italiano per tutta la durata del soggiorno.",
    },
    {
        q: "Parlate italiano?",
        a: "Sì. Il nostro team parla italiano: dalla prima consulenza su WhatsApp fino al follow-up dopo il rientro, sarai sempre seguito nella tua lingua.",
    },
    {
        q: "Che garanzia offrite sugli impianti?",
        a: "Utilizziamo esclusivamente impianti certificati CE con garanzia scritta. Al termine del trattamento riceverai tutta la documentazione e il piano dei controlli periodici.",
    },
    {
        q: "Come invio la panoramica?",
        a: "Scatta una foto alla panoramica o invia il file direttamente su WhatsApp al 351 372 3773. Riceverai un preventivo gratuito e senza impegno entro 24 ore.",
    },
];
